import { render, staticRenderFns } from "./DefaultOrValueForm.vue?vue&type=template&id=8934bb68&scoped=true"
import script from "./DefaultOrValueForm.vue?vue&type=script&lang=js"
export * from "./DefaultOrValueForm.vue?vue&type=script&lang=js"
import style0 from "./DefaultOrValueForm.vue?vue&type=style&index=0&id=8934bb68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8934bb68",
  null
  
)

export default component.exports